import React from 'react';
import styled from 'styled-components';
import BubbleStep, { Status } from './BubbleStep';

const Container = styled.div`
  display: flex;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    padding-top: 30px;
  }
`;

type Props = {
  steps: string[];
  selectedStep: number;
  onSelectStep: (index: number) => void;
};

function determineStatus(stepIndex: number, selectedStepIndex: number): Status {
  if (stepIndex === selectedStepIndex) return Status.InProgress;

  if (stepIndex < selectedStepIndex) return Status.Completed;

  return Status.Todo;
}

const BubbleStepTracker = (props: Props) => {
  const { steps, selectedStep } = props;
  const renderedSteps = steps.map((title, index) => {
    const status = determineStatus(index, selectedStep);

    return <BubbleStep key={index} status={status} title={title} showSpacer={index !== 0} />;
  });

  return <Container>{renderedSteps}</Container>;
};

export default BubbleStepTracker;
